
import { Drawer, Input, Select, Option } from "element-ui"
import { getGoogleMapAddress, getLocationByPlaceId, checkAddressValidForAnyStore } from "@/api/address"

export default {
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "add"
    }
  },
  data() {
    return {
      drawer: this.visible,
      searchValue: "",
      list: [],
      loading: false,
      showWarnMessage: false,
      warnMessage: ""
    }
  },
  watch: {
    visible(val) {
      this.drawer = val
    }
  },
  methods: {
    getAddressList(query) {
      if (query !== "") {
        this.loading = true
        getGoogleMapAddress({
          param: JSON.stringify({
            keyword: query
          })
        })
          .then(res => {
            if (res.data) {
              this.list = res.data
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.loading = false
          })
      }
    },
    handleListItem(item) {
      if (this.showWarnMessage) return
      checkAddressValidForAnyStore({
        param: JSON.stringify({ lat: item.latitude, lng: item.longitude })
      }).then(res => {
        if (res.code === "0000") {
          if (res.data) {
            getLocationByPlaceId({
              param: JSON.stringify({ placeId: item.placeId, sessionToken: item.sessionToken })
            }).then(res => {
              if (res.code === "0000") {
                if (res.data) {
                  this.$emit("getAddress", res.data)
                  this.handleClose()
                }
              }
            })
          } else {
            this.showWarnMessage = true
            this.warnMessage = res.result
            setTimeout(() => {
              this.showWarnMessage = false
            }, 3000)
          }
        }
      })
    },
    handleClose() {
      this.$emit("close")
    },
    handleClear() {
      this.searchValue = ""
      this.list = []
    }
  }
}
